module.exports = __webpack_public_path__ + "static/fantasy-ab9af85d1446aeb9120d5ab671a26947.png";